import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

type WrapperProps = {
  width?: string
}

export const Wrapper = styled.div<WrapperProps>`
  flex-shrink: 0;

  ${({ theme }) => `
    width: 100%;
    font-weight: ${theme.fontWeight.semibold};
  `}

  ${({ theme, width }) => media.sm`
    width: ${width};
    padding-right: ${theme.space.mobile.small};
    border-right: 2px solid ${theme.color.greyLight};
  `}
`
